import { Component, OnInit, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { YoutubeVideoModalComponent } from '../../shared/components/modals/youtube-video-modal/youtube-video-modal.component';
import { YoutubeService } from '../../shared/services/youtube.service';
import { AuthService } from '../../shared/services/auth.service';
import { VideoData } from '../../shared/interfaces';
import { VIDEO_TAG_LABELS } from '../../shared/enums';

@Component({
  selector: 'app-how-to-guide-page',
  templateUrl: './how-to-guide-page.component.html',
  styleUrls: ['./how-to-guide-page.component.scss']
})
export class HowToGuidePageComponent implements OnInit, OnDestroy {
  videos: VideoData[] | null = null;
  tagsList: string[] = [];
  selectedTags: string[] = [];

  get videosToShow(): VideoData[] {
    if (!this.videos) return [];
    if (this.selectedTags.length === 0) return this.videos;

    return this.videos.filter((video) => {
      return (this.selectedTags.includes(VIDEO_TAG_LABELS.NEW) && video.isNew) || video.tags.some((tag) => this.selectedTags.includes(tag));
    });
  }

  protected readonly VIDEO_TAG_LABELS = VIDEO_TAG_LABELS;

  constructor(
    public authService: AuthService,
    public youtubeService: YoutubeService,
    private readonly dialogService: MatDialog
  ) {}

  ngOnInit(): void {
    this.youtubeService.videos$.subscribe((videos) => {
      this.videos = videos;
      if (this.videos) this.tagsList = this.getUniqueTags(this.videos);
    });

    this.youtubeService.updateVideosList();
  }

  getUniqueTags(videos: VideoData[]): string[] {
    return Array.from(new Set(videos.flatMap((v) => v.tags)));
  }

  onTagClick(tag: string): void {
    if (tag === VIDEO_TAG_LABELS.ALL) {
      this.selectedTags = [];
    } else {
      const index = this.selectedTags.indexOf(tag);
      if (index === -1) {
        this.selectedTags.push(tag);
      } else {
        this.selectedTags.splice(index, 1);
      }
    }
  }

  openVideoModal(video: VideoData = {} as VideoData) {
    this.dialogService.open(YoutubeVideoModalComponent, {
      panelClass: ['dialog-overlay-pane'],
      data: {
        ...video
      },
      width: '850px'
    });
  }

  ngOnDestroy(): void {
    this.youtubeService.clearData();
  }
}
